import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Router } from '@angular/router';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';

@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.css']
})
export class SiteHeaderComponent implements OnInit {

  @Input('loginUserData') public loginUserData;

  hideSideBar=false;

  constructor(private authService:AuthService,private router:Router,private behaviorModelChangeService:BehaviorModelChangeService) { }

  ngOnInit() {
  }

  onLogOut(e){
    e.preventDefault()

    this.authService.logout();
    this.router.navigate(['/account/login']);

  }
  onProfile(e){
    e.preventDefault();
  }

  onChangeSideBar(e){
    e.preventDefault();
    if(this.hideSideBar){
      this.behaviorModelChangeService.onsideBarChange('app sidebar-mini rtl pace-done');
    }else{
      this.behaviorModelChangeService.onsideBarChange('app sidebar-mini rtl pace-done sidenav-toggled');
    }
    this.hideSideBar=!this.hideSideBar;

  }
  
  onSetting(e){
    e.preventDefault();

  }

}
